export default {
  namespaced: true,
  state: {
    appConfig: {
      carReasonRequiredCode: '', // '1'-出差需要用车事由 '2'-工作地需要用车事由 '1,2'-都需要用车事由
      temporaryCarNotNeedReason: false, // 临时用车不需要用车事由
      openSavingBonus: false, //是否开通节省奖励配置
      provisionalBudget: [], // 出差单临时预算
      isDynamicStandard: false, // 出差单动态差标
      isChannelCustomer: false, // 渠道客户
      carServiceProvider: [], // 用车服务商 2-极速 3-滴滴出行
      isDidiEntrance: false, // 是否滴滴独立入口
    },
  },
  getters: {
    // 是否开通节省奖励配置
    openSavingBonus: (state) => state.appConfig.openSavingBonus,
  },
  mutations: {
    setAppConfig(state, data) {
      state.appConfig = {
        ...state.appConfig,
        ...data,
      };
    },
  },
};
